import { Link, useLocation } from 'react-router-dom'
import { TREATMENTS_NAV } from './Navbar'
import ElfsightGoogleReviews from './ElfsightGoogleReviews'

export default function Footer() {
  const currentYear = new Date().getFullYear()
  const location = useLocation()
  const isHomePage = location.pathname === '/'
  const normalizedPath = location.pathname.replace(/\/$/, '') || '/'
  const hideReviews = ['/priser', '/referencer', '/profil', '/om-trine', '/kontakt'].includes(normalizedPath)

  return (
    <footer className="border-t border-[#D2DEC7] bg-[#E4ECE0] text-[#2C3826] transition-colors">
      {/* Reassurance Bar - Only shown on front page */}
      {isHomePage && (
        <div className="border-b border-[#D2DEC7]/80 py-8 bg-[#EDF4E9]">
          <div className="mx-auto max-w-6xl px-5 sm:px-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="flex flex-col items-center text-center gap-2.5">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#DDE9D4] text-[#5C7A4F]">
                  <i className="fa-solid fa-heart text-sm" aria-hidden="true" />
                </div>
                <div>
                  <h4 className="font-serif text-base font-medium text-[#24301D]">
                    Tryghed & nærvær
                  </h4>
                  <p className="text-xs text-[#5A6D52] mt-1 max-w-xs mx-auto">
                    Et personligt, etisk og professionelt terapeutisk samarbejde.
                  </p>
                </div>
              </div>

              <div className="flex flex-col items-center text-center gap-2.5">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#DDE9D4] text-[#5C7A4F]">
                  <i className="fa-solid fa-seedling text-sm" aria-hidden="true" />
                </div>
                <div>
                  <h4 className="font-serif text-base font-medium text-[#24301D]">
                    Naturlig ro & forandring
                  </h4>
                  <p className="text-xs text-[#5A6D52] mt-1 max-w-xs mx-auto">
                    Giv slip på det ubevidste og genfind kroppens og sindets balance.
                  </p>
                </div>
              </div>

              <div className="flex flex-col items-center text-center gap-2.5">
                <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#DDE9D4] text-[#5C7A4F]">
                  <i className="fa-solid fa-clock text-sm" aria-hidden="true" />
                </div>
                <div>
                  <h4 className="font-serif text-base font-medium text-[#24301D]">
                    God tid til hver behandling
                  </h4>
                  <p className="text-xs text-[#5A6D52] mt-1 max-w-xs mx-auto">
                    1 time og 20 minutter afsat pr. session, så intet forhastes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Google Anmeldelser placeret lige efter tryghedsbåndet */}
      {!hideReviews && (
        <section className="border-b border-[#D2DEC7]/80 py-10 bg-[#faf9f5]">
          <div className="mx-auto max-w-6xl px-5 sm:px-6 space-y-6">
            <div className="text-center space-y-1">
              <span className="text-xs uppercase tracking-widest text-[#556B48] font-medium">
                Google Anmeldelser
              </span>
              <h3 className="font-serif text-xl sm:text-2xl font-normal text-[#242E1F]">
                Hvad klienterne siger om Trine Rosendal
              </h3>
            </div>
            <ElfsightGoogleReviews />
          </div>
        </section>
      )}

      {/* Main footer content */}
      <div className="mx-auto max-w-6xl px-5 sm:px-6 py-12 lg:py-16 text-center">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          {/* Col 1: Brand & Profile */}
          <div className="space-y-3 flex flex-col items-center">
            <Link to="/" className="inline-block">
              <span className="font-serif text-2xl font-medium text-[#2B3824]">
                Trine Rosendal
              </span>
            </Link>
            <p className="text-xs leading-relaxed text-[#4F5E48] max-w-sm">
              Siden 2007 har jeg hjulpet børn, unge og voksne med at give slip på uro, angst og uhensigtsmæssige mønstre.
            </p>
            <div className="pt-1">
              <a
                href="https://www.facebook.com/hypnosetrine/#"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-1.5 text-xs text-[#4F5E48] hover:text-[#242E1F] transition"
              >
                <i className="fa-brands fa-facebook text-[#5C7A4F] text-sm" aria-hidden="true" />
                <span>Følg Trine på Facebook</span>
              </a>
            </div>
          </div>

          {/* Col 2: Behandlinger */}
          <div className="flex flex-col items-center">
            <p className="font-serif text-lg sm:text-xl font-medium text-[#2B3824] mb-3">
              Behandlinger
            </p>
            <ul className="space-y-1.5 text-xs">
              <li>
                <Link to="/hypnose" className="font-medium text-[#5C7A4F] hover:text-[#242E1F] transition">
                  Hypnoterapi
                </Link>
              </li>
              {TREATMENTS_NAV.slice(0, 5).map((item) => (
                <li key={item.slug}>
                  <Link
                    to={`/behandlinger/${item.slug}`}
                    className="text-[#4F5E48] hover:text-[#242E1F] transition"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
              <li className="pt-1">
                <Link
                  to="/behandlinger"
                  className="font-medium text-[#5C7A4F] hover:underline"
                >
                  Se alle 17 behandlingsområder →
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Kontakt & Tidsbestilling */}
          <div className="space-y-3 text-xs text-[#4F5E48] flex flex-col items-center">
            <p className="font-serif text-lg sm:text-xl font-medium text-[#2B3824]">
              Kontakt & booking
            </p>
            <p>
              <strong className="text-[#2B3824]">Klinikken:</strong><br />
              Prins Burisvej 41.A, 7500 Holstebro
            </p>
            <p>
              <strong className="text-[#2B3824]">Telefon:</strong>{' '}
              <a href="tel:42510105" className="hover:underline text-[#2B3824] font-medium">
                42 51 01 05
              </a>
            </p>
            <p>
              <strong className="text-[#2B3824]">E-mail:</strong>{' '}
              <a href="mailto:info@trine-rosendal.dk" className="hover:underline">
                info@trine-rosendal.dk
              </a>
            </p>
            <p className="text-[11px] text-[#72856A]">CVR: 31231051</p>
            <div className="pt-1">
              <a
                href="https://system.easypractice.net/book/online-booking-16"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-[#5C7A4F] px-4 py-2 text-xs font-medium text-white shadow-xs transition hover:bg-[#455C3A]"
              >
                <span>Book tid online</span>
                <i className="fa-solid fa-arrow-right text-[10px]" aria-hidden="true" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom copyright */}
        <div className="border-t border-[#D2DEC7] pt-6 mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#617459]">
          <p>© {currentYear} Trine Rosendal. Alle rettigheder forbeholdes.</p>
          <p className="text-[11px]">
            Certificeret hypnoterapeut og healer i Holstebro
          </p>
        </div>
      </div>
    </footer>
  )
}
